// Keep up to dated with drawing_request.rb

export const drawingTypeOptions = [
  { text: 'Arquitectónicos', value: 'arquitectonico' },
  { text: 'Fabricación', value: 'fabricacion' },
  { text: 'Previstas eléctricas', value: 'previstas_electricas' },
  { text: 'Render 3D', value: 'render_3d' }
]

export const statusOptions = [
  { text: 'Por iniciar', value: 'por_iniciar' },
  { text: 'En proceso', value: 'en_proceso' },
  { text: 'Pend. Info Asesor', value: 'pendiente_informacion_asesor' },
  { text: 'Pend. Info Cliente', value: 'pendiente_informacion_cliente' },
  { text: 'Revisión', value: 'revision' },
  { text: 'Correcciones', value: 'correcciones' },
  { text: 'Entregado', value: 'entregado' },
  { text: 'Desestimado', value: 'desestimado' }
]

export const difficultyLevelOptions = [
  { text: 'Baja', value: 'baja' },
  { text: 'Media', value: 'media' },
  { text: 'Alta', value: 'alta' },
  { text: 'Experto', value: 'experto' }
]

export const statusVariants = {
  por_iniciar: 'success',
  en_proceso: 'warning',
  pendiente_informacion_asesor: 'info',
  pendiente_informacion_cliente: 'info',
  revision: 'warning',
  correcciones: 'info',
  entregado: 'success',
  desestimado: 'dark'
}

export const closedStatuses = [
  'entregado',
  'desestimado'
]

export const sapStatuses = {
  done: { label: 'Sincronizado', class: 'text-success' },
  pending: { label: 'Pendiente', class: 'text-warning' },
  failed: { label: 'Error de sincronización', class: 'text-danger' }
}

export const chatOnlyStatuses = [
  'entregado',
  'desestimado',
  'revision'
]


export const allowedFileTypes = [
  '.pdf',
  '.jpg',
  '.jpeg',
  '.png',
  '.dwg'
]

export const documentKeys = {
  status_revision: { label: 'Revisión', variant: 'warning' },
  status_entregado: { label: 'Entregado', variant: 'success' }
}

export const buildDocumentTags = (comments = []) => {
  const versioned = comments
    .filter(comment => comment.document && documentKeys[comment.document.key_field])
    .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))

  const counters = {}

  return versioned.reduce((tags, comment) => {
    const key = comment.document.key_field
    const { label, variant } = documentKeys[key]
    counters[key] = (counters[key] || 0) + 1

    tags[comment.id] = { key, label, variant, version: counters[key] }
    return tags
  }, {})
}

export const siteOptions = [
  { text: 'Accesos SJ', value: 'Accesos SJ' },
  { text: 'Accesos TG', value: 'Accesos TG' },
  { text: 'Accesos PTY', value: 'Accesos PTY' },
  { text: 'Automátika', value: 'Automátika' },
]
